interface BpTypeBadgeProps {
  /** SAP card type of the business partner — e.g. `cCustomer`, `cSupplier`. */
  type: string;
}

/**
 * Compact K / L / Lead badge indicating whether a business partner is a
 * customer (Kunde), supplier (Lieferant), or lead (Interessent — SAP `cLid`).
 * Shared by the business-partners list and the Verteiler contact tables.
 */
export function BpTypeBadge({ type }: BpTypeBadgeProps) {
  const variant =
    type === 'cCustomer' ? 'customer' : type === 'cSupplier' ? 'supplier' : 'lead';
  const label = type === 'cCustomer' ? 'K' : type === 'cSupplier' ? 'L' : 'Lead';
  return <span className={`bp-type-badge ${variant}`}>{label}</span>;
}
